import { DevBoxHyperVAddOn, DeviceConfiguration } from '../../../models/add-ons';
import { UnionValueMap } from '../../../types/union-map';
import {
    ActionName,
    ActionType,
    ErrorPayload,
    FailedPayload,
    IndexedPayload,
    OptionalResultPayload,
    ResultPayload,
} from '../core-actions';
import { addDevBoxHyperV, addDevBoxHyperVAccepted, pollNonTerminalDevBoxHyperV } from './hyper-v-action-creators';

type DevBoxHyperVActionName =
    | ActionName<'AddDevBoxHyperV', 'Accepted' | 'Error' | 'Failed' | 'Success'>
    | ActionName<'PollNonTerminalDevBoxHyperV', 'Complete' | 'Error'>;

export type DevBoxHyperVActionType =
    | ActionType<'ADD_DEV_BOX_HYPER_V', '_ACCEPTED' | '_ERROR' | '_FAILED' | '_SUCCESS'>
    | ActionType<'POLL_NON_TERMINAL_DEV_BOX_HYPER_V', '_COMPLETE' | '_ERROR'>;

export const DevBoxHyperVActionType: UnionValueMap<DevBoxHyperVActionName, DevBoxHyperVActionType> = {
    AddDevBoxHyperV: 'ADD_DEV_BOX_HYPER_V',
    AddDevBoxHyperVAccepted: 'ADD_DEV_BOX_HYPER_V_ACCEPTED',
    AddDevBoxHyperVError: 'ADD_DEV_BOX_HYPER_V_ERROR',
    AddDevBoxHyperVFailed: 'ADD_DEV_BOX_HYPER_V_FAILED',
    AddDevBoxHyperVSuccess: 'ADD_DEV_BOX_HYPER_V_SUCCESS',
    PollNonTerminalDevBoxHyperV: 'POLL_NON_TERMINAL_DEV_BOX_HYPER_V',
    PollNonTerminalDevBoxHyperVComplete: 'POLL_NON_TERMINAL_DEV_BOX_HYPER_V_COMPLETE',
    PollNonTerminalDevBoxHyperVError: 'POLL_NON_TERMINAL_DEV_BOX_HYPER_V_ERROR',
};

/**
 * Payloads
 */

export interface AddDevBoxHyperVPayload extends IndexedPayload {
    name: string;
    deviceConfiguration: DeviceConfiguration;
}

export type PollNonTerminalDevBoxHyperVCompletePayload = IndexedPayload & OptionalResultPayload<DevBoxHyperVAddOn>;
export type AddDevBoxHyperVAcceptedPayload = IndexedPayload & ResultPayload<DevBoxHyperVAddOn>;
export type AddDevBoxHyperVErrorPayload = ErrorPayload & IndexedPayload;
export type AddDevBoxHyperVFailedPayload = FailedPayload & IndexedPayload;
export type AddDevBoxHyperVSuccessPayload = IndexedPayload & ResultPayload<DevBoxHyperVAddOn>;

/**
 * Action shorthands
 */

export type AddDevBoxHyperVAction = ReturnType<typeof addDevBoxHyperV>;
export type AddDevBoxHyperVAcceptedAction = ReturnType<typeof addDevBoxHyperVAccepted>;
export type PollNonTerminalDevBoxHyperVAction = ReturnType<typeof pollNonTerminalDevBoxHyperV>;
